import acquisitionTypes, {
  acquisitionTypeTitles,
} from '../../support/acquisitionTypes';
import type { SubscriptionRoutingContext, AcquisitionTab } from './types';
import subscriptionDownloadRule from './subscriptionDownloadRule';
import alacarteRule from './alacarteRule';
import subscriptionLicenseRule from './subscriptionLicenseRule';

const SUBSCRIPTION_RULES = [
  subscriptionDownloadRule,
  subscriptionLicenseRule,
  alacarteRule,
];

const DOWNLOAD_TAB: AcquisitionTab = {
  type: acquisitionTypes.DOWNLOAD,
  title: acquisitionTypeTitles.DOWNLOAD,
};

const composeTabStack = (
  winner: AcquisitionTab,
  assetIsDownloadable: boolean
): AcquisitionTab[] => {
  if (winner.type === acquisitionTypes.SUBSCRIPTION_DOWNLOAD) return [winner];
  return assetIsDownloadable ? [DOWNLOAD_TAB, winner] : [winner];
};

export const resolveSubscriptionAcquisitionType = (
  context: SubscriptionRoutingContext
): AcquisitionTab[] | null => {
  for (const rule of SUBSCRIPTION_RULES) {
    const result = rule(context);
    if (result) return composeTabStack(result, context.assetIsDownloadable);
  }
  return null;
};

export type { SubscriptionRoutingContext, AcquisitionTab };
